import { connect } from 'react-redux';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { getShopItemsStreamId } from '../../../../../streams/shop';
import { ShopItemType } from '../../../../../../types/shop';
import { ModuleType } from '../../../../../../types/modules';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
} from '../../../../../selectors/users';
import { getModuleDataByModuleType } from '../../../../../selectors/modules';
import { openCommissionEditModal } from '@wix/da-shared-react/pkg/redux/commissions/actionCreators';

export default connect(
  state => {
    const streamId = getShopItemsStreamId(ShopItemType.COMMISSIONS);
    const { isOpenForCommissions } = getModuleDataByModuleType(
      state,
      ModuleType.COMMISSIONS
    );

    return {
      streamId,
      isOpenForCommissions,
      commissions: getDeviationsByIds(
        state,
        streamSelectors.getItems(state, streamId)
      ),
      total: streamSelectors.getTotal(state, streamId),
      isOwner: isCurrentUserProfileOwner(state),
      username: getProfileOwnerUser(state).username,
    };
  },
  { openCommissionEditModal }
);
